var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.125 3.5L19.6583 1.48791C20.3104 1.25075 21 1.73374 21 2.4277V17.7996C21 18.2201 20.7369 18.5957 20.3417 18.7394L14.125 21M14.125 3.5L7.25 1M14.125 3.5V21M7.25 1L1.62861 3.24856C1.24895 3.40042 1 3.76813 1 4.17703V19.523C1 20.2304 1.71453 20.7142 2.37139 20.4514L7.25 18.5M7.25 1V18.5M7.25 18.5L14.125 21",
    stroke: "#393939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaps);
export default __webpack_public_path__ + "static/media/maps.3d7218f0a52a732b82b2e770ccfe6fbc.svg";
export { ForwardRef as ReactComponent };